import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "footer" }

import { showDeleteChatDialogue } from "@/components/Dialogues/useData/useDialogues";

import { chatStatus } from "@/views/Home/useData/module/chat";


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteChatHistoryDialogue',
  setup(__props) {

const endEdit = () => {
  showDeleteChatDialogue.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _unref(showDeleteChatDialogue),
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(showDeleteChatDialogue) ? (showDeleteChatDialogue).value = $event : null)),
    width: "300",
    class: "custom",
    "align-center": "",
    center: "",
    "show-close": false
  }, {
    header: _withCtx(() => _cache[2] || (_cache[2] = [])),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showDeleteChatDialogue.value = false)),
          type: ""
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("取消 ")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: endEdit
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("确定")
          ])),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "content" }, [
        _createElementVNode("div", { class: "title" }, "确定删除对话吗？"),
        _createElementVNode("div", { class: "input-content" }, " 删除后该对话记录无法恢复和找回，请谨慎操作。 ")
      ], -1))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})